/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_M2_YearInputs */

const cs_enum_m2_year = /** @type {(inputs: Enum_M2_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m² / rok`)
};

const en_enum_m2_year = /** @type {(inputs: Enum_M2_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m² / year`)
};

/**
* | output |
* | --- |
* | "m² / year" |
*
* @param {Enum_M2_YearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_m2_year = /** @type {((inputs?: Enum_M2_YearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_M2_YearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_m2_year(inputs)
	return cs_enum_m2_year(inputs)
});